import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              精选热门视频
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              大家都在看的热门内容
            </p>
          </div>
          <Link
            to="/category/aiqing-ju"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.categorySlug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
                  {video.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                    热门
                  </span>
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100">
                    <i className="ri-play-fill text-2xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-400 mb-3 line-clamp-2">
                  {video.description}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </span>
                    {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                      <i className="ri-star-fill"></i>
                    </span>
                    {video.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}